module.exports = __webpack_public_path__ + "static/media/ic_redo_red.5d645116.svg";